import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './component/home/home.component';
import { GyztComponent } from './component/gyzt/gyzt.component';
import { HzComponent } from './component/hz/hz.component';
import { XzComponent } from './component/xz/xz.component';
import { YfgcComponent } from './component/yfgc/yfgc.component';
import { TdComponent } from './component/td/td.component';
import { SqComponent } from './component/sq/sq.component';
import { SyffComponent } from './component/syff/syff.component';
import { VsBotComponent } from './component/td/vs-bot/vs-bot.component';
import { VsNsmComponent } from './component/td/vs-nsm/vs-nsm.component';
import { VsBtComponent } from './component/td/vs-bt/vs-bt.component';
import { AzComponent } from './component/syff/az/az.component';
import { DetailsComponent } from './component/xz/details/details.component';
import { WebComponent } from './component/syff/web/web.component';
import { OfficeComponent } from './component/syff/office/office.component';
import { AppletsComponent } from './component/syff/applets/applets.component';
import { CountComponent } from './component/count/count.component';



const routes: Routes = [
  { path: '', redirectTo: '/index', pathMatch: 'full' },
  {path: 'index', component: HomeComponent,data: {title: '首页'}},
  {path: 'aboutFonts', component: GyztComponent,data: {title: '关于字体'}},
  {path: 'process', component: YfgcComponent,data: {title: '研发过程'}},
  {path: 'characteristic', component: TdComponent,children: [
    {path: '', redirectTo: 'VsBt', pathMatch: 'full' },
    {path: 'VsBt', component: VsBtComponent, data: {title: '特点：蒙古文无衬线报体与蒙古文白体比较'}},
    {path: 'VsBot', component: VsBotComponent, data: {title: '特点：蒙古文无衬线报体与蒙古文报体比较'}},
    {path: 'VsNsm', component: VsNsmComponent, data: {title: '特点：蒙古文无衬线报体与Noto sans Mongolian比较'}}
  ]},

  {path: 'Download', component: XzComponent, data: {title: '下载'}},
  {path: 'Download/1', component: DetailsComponent, data: {title: '下载'}},

  {path: 'authorize', component: SqComponent, data: {title: '授权'}},
  {path: 'usageMethod', component: SyffComponent, children: [
    {path: '', redirectTo: 'install', pathMatch: 'full' },
    {path: 'install', component: AzComponent, data: {title: '使用方法：安装指南'}},
    {path: 'web', component: WebComponent, data: {title: '使用方法：嵌入网页'}},
    {path: 'office', component: OfficeComponent, data: {title: '使用方法：嵌入办公软件'}},
    {path: 'applets', component: AppletsComponent, data: {title: '使用方法：嵌入小程序'}}

  ]},
  {path: 'cooperation', component: HzComponent, data: {title: '合作'}},
  {path: 'count', component: CountComponent, data: {title: '统计'}},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
